import { SettlementState, SettlementUnloadState } from '../../states/SettlementState';

// Settlement Reducer
import { Action, Reducer } from 'redux';

// actions
import * as Actions from '../../actions';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';

type KnownAction = 
| Actions.SettlementsDeatils.SettlementDetails_GetAll_Request_Action
| Actions.SettlementsDeatils.SettlementDetails_GetAll_Receive_Action
| Actions.SettlementsDeatils.SettlementDetails_GetAll_Fail_Action


export const SettlementDetailsReducer: Reducer<SettlementState> = (
    state: SettlementState | undefined, incomingAction: Action): SettlementState => {
    
        if (state === undefined) {
            return SettlementUnloadState as SettlementState;
        }
    
        const action = incomingAction as KnownAction;

        var CurrentSettlement: Settlement | undefined = undefined;

        switch (action.type) {
            case 'SETTLEMENTDETAILS_GETALL_REQUEST_ACTION':
                CurrentSettlement = state.list && state.list.length > 0 ? state.list.find((settlement: Settlement) => settlement.id === action.settlementId) : undefined;

                if (CurrentSettlement) {
                    CurrentSettlement.isGettingDetails = true;
                    CurrentSettlement.isGettingDetailsSuccess = undefined;
                    CurrentSettlement.failOnGettingDetails = false;
                    CurrentSettlement.ErrorGettingDetails = undefined;
                }

                return {
                    ...state,
                    list: CurrentSettlement ? [...state.list!.filter((settlement: Settlement) => settlement.id !== action.settlementId), CurrentSettlement] : state.list,
                };
            case 'SETTLEMENTDETAILS_GETALL_RECEIVE_ACTION':
                CurrentSettlement = state.list && state.list.length > 0 ? state.list.find((settlement: Settlement) => settlement.id === action.settlementId) : undefined;

                if (CurrentSettlement) {
                    CurrentSettlement.isGettingDetails = false;
                    CurrentSettlement.isGettingDetailsSuccess = true;
                    CurrentSettlement.failOnGettingDetails = false;
                    CurrentSettlement.ErrorGettingDetails = undefined;
                    CurrentSettlement.details = action.settlementDetails;
                }

                return {
                    ...state,
                    list: CurrentSettlement ? [...state.list!.filter((settlement: Settlement) => settlement.id !== action.settlementId), CurrentSettlement] : state.list, 
                    
                };
            case 'SETTLEMENTDETAILS_GETALL_FAIL_ACTION':
                CurrentSettlement = state.list && state.list.length > 0 ? state.list.find((settlement: Settlement) => settlement.id === action.settlementId) : undefined;

                if (CurrentSettlement) {
                    CurrentSettlement.isGettingDetails = false;
                    CurrentSettlement.isGettingDetailsSuccess = false;
                    CurrentSettlement.failOnGettingDetails = true;
                    CurrentSettlement.ErrorGettingDetails = action.error;
                }

                return {
                    ...state,
                    list: CurrentSettlement ? [...state.list!.filter((settlement: Settlement) => settlement.id !== action.settlementId), CurrentSettlement] : state.list,
                };
            default:
                return state;
        }
    }

